import * as React from "react";
import Dialog from "../Dialog";

import { IUser } from "../../../types";

import DialogButtonContainer from "../../DialogComponents/Buttons/ButtonContainer";
import DialogButton from "../../DialogComponents/Buttons/Button";

import { clone, pull } from "lodash";

interface Props {
    onSubmit: (checked: string[], name: string) => any;
    onCloseDialog: () => any;
    contacts: IUser[];
    hideInputName?: boolean;
}

interface State {
    checked: string[];
    name: string;
}

const s = require("./CreateGroupDialog.scss");

class InvitePatientDialog extends React.Component<Props, State> {
    constructor(props: Props, context: any) {
        super(props, context);

        this.state = {
            checked: [],
            name: ""
        };
    }

    toggleCheckbox(contactId: string) {
        let checkedContacts = clone(this.state.checked);
        let newState: string[];

        if (checkedContacts.indexOf(contactId) === -1) {
            newState = checkedContacts.concat(contactId);
        } else {
            newState = pull(checkedContacts, contactId);
        }

        this.setState({
            checked: newState
        } as any);
    }

    onSubmit() {
        this.props.onSubmit(this.state.checked, this.state.name);
    }

    onNameChange(event: React.FormEvent<HTMLInputElement>) {
        this.setState({
            name: (event.target as HTMLInputElement).value
        } as any);
    }

    render(): JSX.Element {
        const contacts = this.props.contacts.map(contact => {
            return (
                <li key={contact.id}>
                    <label>
                        <input type="checkbox" onChange={event => this.toggleCheckbox(contact.id)}/>
                        {contact.name}
                    </label>
                </li>
            );
        });

        return (
            <Dialog
                onCloseDialog={this.props.onCloseDialog}
            >
                <div className={s.createGroup}>
                    <h2>Criar grupo</h2>

                    {!this.props.hideInputName ? (
                    <div>
                        <label>Nome do grupo:</label>
                        <input onChange={event => this.onNameChange(event)} type="text"/>
                    </div>
                    ) : null}

                    <div>
                        <label>Membros:</label>
                        <ul className={s.contacts}>
                            {contacts}
                        </ul>  
                    </div>                   
                </div>

                <DialogButtonContainer>
                    <DialogButton type="reset" onClick={this.props.onCloseDialog}>
                        Cancelar
                    </DialogButton>

                    <DialogButton type="submit" onClick={this.onSubmit.bind(this)}>
                        Criar grupo
                    </DialogButton>
                </DialogButtonContainer>
            </Dialog>
        );
    }
}

export default InvitePatientDialog;



// WEBPACK FOOTER //
// ./src/components/Dialogs/CreateGroupDialog/index.tsx